"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pair = void 0;
var Pair = /** @class */ (function () {
    function Pair(a, b) {
        this.fst = a;
        this.snd = b;
    }
    Object.defineProperty(Pair.prototype, Symbol.toStringTag, {
        get: function () {
            return "Pair( ".concat(this.fst, ", ").concat(this.snd, " )");
        },
        enumerable: false,
        configurable: true
    });
    Pair.isStrictInstance = function (any) {
        if (any === undefined || any === null)
            return false;
        return Object.getPrototypeOf(any) === Pair.prototype;
    };
    Pair.prototype.asObj = function () {
        return {
            fst: this.fst,
            snd: this.snd
        };
    };
    return Pair;
}());
exports.Pair = Pair;
